<template>
  <div class="m-t-3">
    <b-table  small :items="item.master_regions" :fields="masterRegionFields" >

      <template v-slot:table-colgroup="scope">
        <col
          v-for="field in scope.fields"
          :key="field.key"
          :class="{ 'border-left': field.key === 'total' || field.key === 'total_m' || field.key === 'total_f_c'|| field.key === 'total_m_c'  }"
        >
      </template>

      <template v-slot:thead-top="data">
        <b-tr>
          <b-th ></b-th>
          <b-th colspan="2" >M</b-th>
          <b-th colspan="2" >F</b-th>
          <b-th  colspan="3"  >Total</b-th>
          <b-th ></b-th>
        </b-tr>
      </template>

      <template v-slot:cell(show_details)="row">
        <b-button block variant="info" size="sm" v-if="row.detailsShowing" @click="row.toggleDetails" class=""><i class="fa fa-minus"></i></b-button>
        <b-button block variant="info" size="sm" v-if="!row.detailsShowing" @click="row.toggleDetails" class=""><i class="fa fa-plus"></i></b-button>
      </template>

      <template v-slot:row-details="row">
        <div class="p-3">
          <b-table outlined small striped :items="row.item.regions" :fields="regionFields" >

            <template v-slot:thead-top="data">
              <b-tr>
                <b-th ></b-th>
                <b-th colspan="2" >M</b-th>
                <b-th colspan="2" >F</b-th>
                <b-th  colspan="3"  >Total</b-th>
              </b-tr>
            </template>
            <template v-slot:table-colgroup="scope">
              <col
                v-for="field in scope.fields"
                :key="field.key"
                :class="{ 'border-left': field.key === 'total' || field.key === 'total_m' || field.key === 'total_f_c'|| field.key === 'total_m_c'  }"
              >
            </template>
            <template v-slot:cell(total)="data" v-if="showlimits">
              {{ data.item.total }} / {{ data.item.min }}
            </template>
            <template v-slot:cell(total_m)="data" v-if="showlimits">
              {{ data.item.total_m }} / {{ data.item.min_m }}
            </template>
            <template v-slot:cell(total_f)="data" v-if="showlimits">
              {{ data.item.total_f }} / {{ data.item.min_f }}
            </template>
          </b-table>
        </div>
      </template>

      <template v-slot:cell(total)="data"  v-if="showlimits">
        {{ data.item.total }} / {{ data.item.max }}
      </template>

      <template v-slot:cell(total_m)="data" v-if="showlimits">
        {{ data.item.total_m }} / {{ data.item.max_m }}
      </template>
      <template v-slot:cell(total_f)="data" v-if="showlimits">
        {{ data.item.total_f }} / {{ data.item.max_f }}
      </template>

      <template v-slot:cell(total_m_v)="data" v-if="showlimits">
        {{ data.item.total_m_v }} / {{ data.item.max_m_v }}
      </template>
      <template v-slot:cell(total_f_v)="data" v-if="showlimits">
        {{ data.item.total_f_v }} / {{ data.item.max_f_v }}
      </template>

      <template v-slot:cell(total_m_c)="data" v-if="showlimits">
        {{ data.item.total_m_c }} / {{ data.item.max_m_c }}
      </template>
      <template v-slot:cell(total_f_c)="data" v-if="showlimits">
        {{ data.item.total_f_c }} / {{ data.item.max_f_c }}
      </template>
    </b-table>
</div>
</template>
<script>
export default {
  props: ['item', 'showlimits'],
  data() {
    return {
      regionFields: [{
          key: 'name',
          label: 'Subregião',
          sortable: true
      }, {
        key: 'total_m_c',
        label: 'Cal',
        sortable: true
      }, {
        key: 'total_m_v',
        label: 'Vet',
        sortable: true
      }, {
        key: 'total_f_c',
        label: 'Cal',
        sortable: true
      }, {
        key: 'total_f_v',
        label: 'Vet',
        sortable: true
      }, {
        key: 'total_m',
        label: 'M',
        sortable: true
      }, {
        key: 'total_f',
        label: 'F',
        sortable: true
      }, {
        key: 'total',
        label: 'Total',
        sortable: true
      }],
      masterRegionFields: [{
          key: 'name',
          label: 'Região',
          sortable: true
      }, {
        key: 'total_m_c',
        label: 'Cal',
        sortable: true
      }, {
        key: 'total_m_v',
        label: 'Vet',
        sortable: true
      }, {
        key: 'total_f_c',
        label: 'Cal',
        sortable: true
      }, {
        key: 'total_f_v',
        label: 'Vet',
        sortable: true
      }, {
        key: 'total_m',
        label: 'M',
        sortable: true
      }, {
        key: 'total_f',
        label: 'F',
        sortable: true
      }, {
        key: 'total',
        label: 'Total',
        sortable: true
      }, {
        key: 'show_details',
        label: '',
        sortable: true
      }]
    }
  }
}
</script>
